module.exports = __webpack_public_path__ + "media/img/services/services-card-img2-bf2b385734a60071d5a38c2323a2c383.svg";